import { Injectable } from '@angular/core';
import { LoaderService } from '../loader/loader.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DialogService } from '../dialog/dialog.service';
import { LocalStoreService } from '../local-store/local-store.service';
import { environment } from '../../../../../environments/environment';


@Injectable({
	providedIn: 'root'
})
export class ApiService {
	httpOptions = {};

	// for server
	prefixUrl: string = "";

	constructor(
		private http: HttpClient,
		private loaderService: LoaderService,
		private authStore: LocalStoreService,
		public dialogService: DialogService,
	) {

		this.prefixUrl = environment.apiHost;

	}

	get<T>(url: string, showLoader: boolean = true): Observable<T> {
		url = this.prefixUrl + url;

		this.httpOptions = {
			headers: new HttpHeaders(
				{
					"show-loader": showLoader.toString(),
				}
			)
		};

		return this.http.get<T>(url, this.httpOptions)
			.pipe(
				map(res => {
					if (showLoader)
						this.loaderService.display(false);
					return res;
				}),
				catchError(this.handleError<T>(url))
			);
	}

	post<D, R>(url: string, data?: D, showLoader: boolean = true): Observable<R> {
		url = this.prefixUrl + url;

		this.httpOptions = {
			headers: new HttpHeaders(
				{
					"show-loader": showLoader.toString(),
					'Content-Type': 'application/json'
				}
			)
		};

		return this.http.post<R>(url, data, this.httpOptions)
			.pipe(
				map(res => {
					if (showLoader)
						this.loaderService.display(false);
					return res;
				}),
				catchError(this.handleError<R>(url))
			);
	}

	/**
  * Handle Http operation that failed.
  * Let the app continue.
  */
	private handleError<T>(url = '') {
		return (error: any): Observable<T> => {
			this.loaderService.display(false);

			var errMsg: string;
			console.log(error);
			switch (error.status) {
				case 0:
					errMsg = "Network error. Please check your internet connection.";
					this.dialogService.error(errMsg);
					parent.postMessage({"errMsg": errMsg}, '*');
					return throwError(error.error);

				case 404:
					errMsg = "Resource not found. Please contact customer support";
					parent.postMessage({"status": 404,"errMsg": errMsg}, '*');
					this.dialogService.error(errMsg);
					return throwError(error.error);

				case 403:
					errMsg = "You don't have permission to perform this operation.";
					this.dialogService.error(errMsg);
					parent.postMessage({"status": '403',"errMsg": errMsg}, '*');
					return throwError(error.error);

				case 401:
					errMsg = "Session timed out. Please login again.";
					this.dialogService.error(errMsg);
					//this.authStore.forceLogout();
					parent.postMessage({"status": '401',"errMsg": errMsg}, '*');
					return throwError(error.error);
			}

			if (error.status >= 400) {
				console.log(error);
				if (error.error.ErrorMessage)
					errMsg = error.error.ErrorMessage;
				else
					errMsg = error.message;

				//Not Allowed Error - silently throw error and return
				if (error.error.ErrorNumber == 50004 && error.error.ErrorState > 100)
					return throwError(error.error);

				//SHOW ERROR MESSAGE DIALOG
				this.dialogService.error(errMsg);

				if ((error.error.ErrorNumber == 50009 && error.error.ErrorState > 100) || error.error.ErrorNumber == 50012) {
					//Authentication error or Critical error - Force user logout
					this.authStore.forceLogout();
					return throwError(error.error);
				}
			}

			return throwError(error.error);
		};
	}

	public getToken(url: string): string {
		var authToken = this.authStore.getToken();
		if (authToken === null) authToken = "";
		if (authToken === "") {
			this.authStore.forceLogout();
		}
		else {
			return authToken;
		}
	}
}
